import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAmazonalexaComponent } from './simple-icons-amazonalexa.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAmazonalexaComponent ],
    exports:      [ SimpleIconsAmazonalexaComponent ],
    bootstrap:    []
})
export class SimpleIconsAmazonalexaModule {}
